import React, { useEffect, useState } from "react";

import prev_light from "styles/common/img/common/prev_light.png";
import prev_light_active from "styles/common/img/common/prev_light_active.png";
import next_light from "styles/common/img/common/next_light.png";
import next_light_active from "styles/common/img/common/next_light_active.png";
import prev_dark from "styles/common/img/common/prev_dark.png";
import prev_dark_active from "styles/common/img/common/prev_dark_active.png";
import next_dark from "styles/common/img/common/next_dark.png";
import next_dark_active from "styles/common/img/common/next_dark_active.png";
import { useSelector, useDispatch } from "react-redux";
import { ANOUN_DETAILED_REQUEST, GO_ANOUN_LIST, NIMPT_ANOUNALL_REQUEST } from "containers/csboard/Action";

const Notice_detail = (props) => {
    const { user_id, mode, anounDetailed, file } = props;

    const dispatch = useDispatch();

    const [disabledPrev, setDisabledPrev] = useState(false);
    const [disabledNext, setDisabledNext] = useState(false);

    const [prevBtn, setPreBtn] = useState(1);
    const [nextBtn, setNextBtn] = useState(1);
    const [index, setIndex] = useState("");
    const [fileimgPath, setFileimgPath] = useState("");

    const anounSeq = useSelector((state) => state.csboardReducer.anounSeq);
    const searchType = useSelector((state) => state.csboardReducer.searchType);
    const searchTxt = useSelector((state) => state.csboardReducer.searchTxt);
    const disabledBtn = useSelector((state) => state.csboardReducer.disabledBtn);

    const nimptAllList = useSelector((state) => state.csboardReducer.nimptAllList);
    const imptAllList = useSelector((state) => state.csboardReducer.imptAllList);

    useEffect(() => {
        dispatch(
            NIMPT_ANOUNALL_REQUEST({
                headerParam: user_id,
                searchType: searchType,
                keyword: searchTxt,
                from: "",
                size: "",
            }),
        );
    }, [searchType]);

    //maxSeq와 minSeq 담을 배열
    let seqArr = [];
    //공지사항(detailed) 담을 배열
    let anoun = [];

    for (var obj in anounDetailed) {
        anoun[obj] = anounDetailed[obj];
    }

    for (var obj in anounSeq) {
        seqArr[obj] = anounSeq[obj];
    }

    const imptMaxSeq = seqArr.imptMaxSeq;
    const nimptMaxSeq = seqArr.nimptMaxSeq;

    const compareSeq = anoun.ANOUN_SEQ;

    let nimptArr = [];
    let imptArr = [];

    const imptLength = imptAllList.length;
    nimptAllList.map((ele, i) => {
        ele.INDEX = nimptMaxSeq - i;
        nimptArr.push(ele.ANOUN_SEQ);
    });

    imptAllList.map((ele, i) => {
        ele.INDEX = nimptMaxSeq + (imptLength - i);
        imptArr.push(ele.ANOUN_SEQ);
    });

    const anounInxArr = [...nimptAllList, ...imptAllList];
    //현재 게시글의 seq 값이 동일한 배열
    const found = anounInxArr.filter((ele) => ele.ANOUN_SEQ === compareSeq);

    //현재게시글 배열
    let currentArr = [];

    const arr = found[0];
    for (var obj in arr) {
        currentArr[obj] = arr[obj];
    }

    const i = currentArr.INDEX;

    useEffect(() => {
        setIndex(i);
    }, [i]);

    //다음 게시글의 index 값과 동일한 배열
    const foundInx = anounInxArr.filter((ele) => ele.INDEX == index);
    const reqInx = foundInx[0];

    const changeArr = [];
    for (var obj in reqInx) {
        changeArr[obj] = reqInx[obj];
    }

    //버튼을 눌렀을때 요청할 seq
    const changeSeq = changeArr.ANOUN_SEQ;
    const fileLength = file?.length;

    //디스패치 한번만되게 해야함 ..
    useEffect(() => {
        if (prevBtn > 1 || nextBtn > 1) {
            dispatch(
                ANOUN_DETAILED_REQUEST({
                    headerParam: user_id,
                    anounSeq: changeSeq,
                }),
            );
        }
    }, [changeSeq]);

    useEffect(() => {
        switch (index) {
            case imptMaxSeq:
                setDisabledPrev(true);
                break;
            case nimptMaxSeq:
                setDisabledPrev(true);
                break;
            case 1:
                setDisabledNext(true);
                break;
        }
    }, [imptMaxSeq, nimptMaxSeq]);

    useEffect(() => {
        if (disabledBtn) {
            setDisabledPrev(true);
            setDisabledNext(true);
        }

        switch (index) {
            case 1:
                setDisabledNext(true);
                break;
            case imptMaxSeq:
                setDisabledPrev(true);
        }

        if (nextBtn > 1 && disabledPrev) setDisabledPrev(false);
        if (prevBtn > 1 && disabledNext) setDisabledNext(false);
    }, [index]);

    useEffect(() => {
        if (fileLength > 0) {
            const filePath = file[0].FILE_PATH;
            const fileName = file[0].FILE_NAME;

            const split = filePath.split("/");

            const imgPath = `${split[2]}/${split[3]}/${split[4]}/${split[5]}/${fileName}`;
            setFileimgPath(`http://down.wjthinkbig.com/${imgPath}`);
        }
    }, [file]);

    const handlePrev = () => {
        setIndex(index + 1);
        setPreBtn(prevBtn + 1);
        setFileimgPath("");
    };

    const handleNext = () => {
        setIndex(index - 1);
        setNextBtn(nextBtn + 1);
        setFileimgPath("");
    };

    const handlePage = () => {
        dispatch(GO_ANOUN_LIST());
    };

    return (
        <>
            <div className="NoticeList position-relative">
                <div className="undertab_tab-bg">
                    <div className="notice-detail_body">
                        <table className="clear notice-detail_head">
                            <tbody>
                                <tr>
                                    <th className="th">제목</th>
                                    <td className="td" colSpan="5">
                                        {anoun.ANOUN_TITE}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="th">구분</th>
                                    <td className="td end">{anoun.SEARCH_TYPE}</td>
                                    <th className="th">등록일</th>
                                    <td className="td end">{anoun.REG_DTM}</td>
                                    <th className="th">조회수</th>
                                    <td className="td data">{anoun.BRWS_CNT}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="notice_content">
                            <div dangerouslySetInnerHTML={{ __html: anoun.ANOUN_CNTT }}></div>
                            {/* <p>{anoun.ANOUN_CNTT}</p><br/> */}
                            {fileLength > 0 && (
                                <div className="cs_img">
                                    <img src={fileimgPath} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="notice-detail_footer">
                        <div className="footer-left fl">
                            {!disabledPrev ? (
                                <div className="prev_btn" onClick={handlePrev}>
                                    {mode ? (
                                        <img src={prev_light_active} className="whiteMode-img" />
                                    ) : (
                                        <img src={prev_dark_active} className="darkMode-img" />
                                    )}
                                    <span>이전글</span>
                                </div>
                            ) : (
                                <div className="prev_btn">
                                    {mode ? (
                                        <img src={prev_light} className="whiteMode-img" />
                                    ) : (
                                        <img src={prev_dark} className="darkMode-img" />
                                    )}
                                    <span>이전글</span>
                                </div>
                            )}
                            {!disabledNext ? (
                                <div className="next_btn" onClick={handleNext}>
                                    <span>다음글</span>
                                    {mode ? (
                                        <img src={next_light_active} className="whiteMode-img" />
                                    ) : (
                                        <img src={next_dark_active} className="darkMode-img" />
                                    )}
                                </div>
                            ) : (
                                <div className="next_btn">
                                    <span>다음글</span>
                                    {mode ? (
                                        <img src={next_light} className="whiteMode-img" />
                                    ) : (
                                        <img src={next_dark} className="darkMode-img" />
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="footer-right fr">
                            <button className="gray-btn" onClick={handlePage}>
                                목록
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notice_detail;
